import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useCustomPageRequest} from '../useCustomPageRequest';
import {ContentBlockSkeleton} from './ContentBlock.skeleton';
import {ContentBlocksView, ContentBlocksViewProps} from './ContentBlocksView';

export const ContentBlocks: React.FC<ContentBlocksViewProps> = props => {
  return (
    <DataFetcher
      request={useCustomPageRequest({})}
      View={ContentBlocksView}
      viewProps={props}
      Loading={ContentBlockSkeleton}
      Error={() => null}
    />
  );
};
